import { httpClient } from '@/lib/http/HttpClient'
import { Country } from '@/models/app'
import { CartDetailResponse } from '@/models/cart'
import { ResponseBase } from '@/models/http'

interface FetchPendingCartParams {
  country: Country
  licenseName: string
  pendingCartToken: string
}

export type PendingCartResponse = CartDetailResponse & {
  pendingCartToken: string
}

export function fetchPendingCart({
  country,
  licenseName,
  pendingCartToken,
}: FetchPendingCartParams) {
  const query = new URLSearchParams({ pendingCartToken })

  return httpClient.fetch<ResponseBase<PendingCartResponse>>(
    `beaches/${licenseName}/carts/pending?${query.toString()}`,
    country
  )
}
